import { lazy } from 'react';

export const Routes = [
    {
        exact: true,
        path: '/create/ticket',
        component: lazy(() => import('src/views/ticket/TicketCreateView')),
    },
    {
        exact: true,
        path: '/management/tickets/:id',
        component: lazy(() => import('src/views/ticket/TicketDetailsView')),
    },
    {
        exact: true,
        path: '/management/tickets',
        component: lazy(() => import('src/views/ticket/TicketListViewV2')),
    },
];
